import React from "react";
import { ArrowPosition } from "./StickyNote";

export enum TourIds {
  WRITE_REWRITE = "write_rewrite",
  FIND_TOUR_AGAIN = "find_tour_again",
  STORY_BIBLE = "story_bible",
  PLUGINS_QUICKSTART = "plugins_quickstart",
  FEEDBACK = "feedback",
  CHAT_ONBOARDING = "chat_onboarding",
  SERIES_FOLDER_INTRO = "series_folder_intro",
  PARAGRAPH_SPACING = "paragraph_spacing",
}

export enum TourSignal {
  PROJECT_CARD_CLICKED = "project_card_clicked",
  NEW_PROJECT_BUTTON_CLICKED = "new_project_button_clicked",
  WRITE_BUTTON_CLICKED = "write_button_clicked",
  EDITOR_LOADED = "editor_loaded",
  INSERT_CLICKED = "insert_clicked",
  HIGHLIGHT_MENU_REWRITE_BUTTON_CLICKED = "highlight_menu_rewrite_button_clicked",
  REWRITE_GO_CLICKED = "rewrite_go_clicked",
  SET_DONE_STREAMING = "set_done_streaming",
  GLOBAL_CLICK = "global_click",
  // Story Bible signals
  STICKY_NEXT = "sticky_next",
  STORY_BIBLE_SCROLLED_INTO_VIEW = "story_bible_scrolled_into_view",
  STORY_BIBLE_SEED_INPUT = "story_bible_seed_input",
  STORY_BIBLE_GENRE_INPUT = "story_bible_genre_input",
  STORY_BIBLE_STYLE_CLICKED = "story_bible_style_clicked",
  STORY_BIBLE_SYNOPSIS_GENERATE_CLICKED = "story_bible_synopsis_generate_clicked",
  STORY_BIBLE_SYNOPSIS_GENERATE_COMPLETED = "story_bible_synopsis_generate_completed",
  STORY_BIBLE_SYNOPSIS_REWRITE_CLICKED = "story_bible_synopsis_rewrite_clicked",
  STORY_BIBLE_SYNOPSIS_REWRITE_COMPLETED = "story_bible_synopsis_rewrite_completed",
  STORY_BIBLE_SYNOPSIS_EDITED = "story_bible_synopsis_edited",
  STORY_BIBLE_CAST_GENERATE_COMPLETED = "story_bible_cast_generate_completed",
  STORY_BIBLE_CAST_GENERATE_CLICKED = "story_bible_cast_generate_clicked",
  STORY_BIBLE_OUTLINE_TYPE_SELECTED = "story_bible_outline_type_selected",
  STORY_BIBLE_OUTLINE_GENERATE_CLICKED = "story_bible_outline_generate_clicked",
  STORY_BIBLE_OUTLINE_GENERATED = "story_bible_outline_generated",
  STORY_BIBLE_OUTLINE_EDITED = "story_bible_chapter_edited",
  STORY_BIBLE_CREATE_DOCUMENT_CLICKED = "story_bible_create_document_clicked",
  STORY_BIBLE_DRAFT_OPENED = "story_bible_draft_opened",
  // Plugins tour signals
  TEXT_SELECTED = "text_selected",
  MORE_TOOLS_CLICKED = "more_tools_clicked",
  PLUGIN_CLICKED = "plugin_clicked",
  // Paragraph spacing tour signals
  SETTINGS_GEAR_CLICKED = "settings_gear_clicked",
  SETTINGS_PANEL_CLOSED = "settings_panel_closed",
  // Feedback tour signals
  FEEDBACK_CHEVRON_CLICKED = "feedback_chevron_clicked",
  FEEDBACK_TYPE_SELECTED = "feedback_type_selected",
  FEEDBACK_BUTTON_CLICKED = "feedback_button_clicked",
  FEEDBACK_COMPLETED = "feedback_completed",
  // Draft signals
  DRAFT_SCENES_GENERATE_CLICKED = "draft_scenes_generate_clicked",
  DRAFT_SCENES_GENERATE_COMPLETED = "draft_scenes_generate_completed",
  DRAFT_PROSE_GENERATE_CLICKED = "draft_prose_generate_clicked",
  DRAFT_PROSE_GENERATE_GO_CLICKED = "draft_prose_generate_go_clicked",
  DRAFT_PROSE_GENERATE_GO_COMPLETED = "draft_prose_generate_completed",
  DRAFT_PROSE_GENERATE_GO_PAUSED = "draft_prose_generate_paused",
  // Failure signals - used to move back a step when generation fails
  STORY_BIBLE_SYNOPSIS_GENERATE_FAILED = "story_bible_synopsis_generate_failed",
  STORY_BIBLE_CAST_GENERATE_FAILED = "story_bible_cast_generate_failed",
  STORY_BIBLE_OUTLINE_GENERATE_FAILED = "story_bible_outline_generate_failed",
  FEEDBACK_FAILED = "feedback_failed",
  FEEDBACK_CANCELLED = "feedback_cancelled",
}

export enum AnchorIds {
  LOGO = "logo",
  PROJECT_CARD = "project_card",
  WRITE_BUTTON = "write_button",
  RIGHT_BAR = "right_bar", // only when right bar is expanded
  RIGHT_BAR_TOGGLE = "right_bar_toggle", // works whether or not right bar is collapsed
  HIGHLIGHT_MENU_REWRITE_BUTTON = "highlight_menu_rewrite_button",
  REWRITE_MENU_DROPDOWN = "rewrite_menu_dropdown",
  TOP_TOOLBAR_REWRITE_BUTTON = "top_toolbar_rewrite_button",
  REWRITE_CARD = "rewrite_card",
  EDITOR = "editor",
  EDITOR_END = "editor_end",
  HELP_ICON = "help_icon",
  RIGHT_BAR_BOTTOM = "right_bar_bottom",
  LEFT_BAR = "left_bar",
  EXIT_TOUR_BUTTON = "exit_tour_button",
  NEW_PROJECT_BUTTON = "new_project_button",
  SERIES_FOLDER_PROJECTS_AREA = "series_folder_projects_area",
  // Story Bible anchors
  STORY_BIBLE_SEED = "story_bible_seed",
  STORY_BIBLE_GENRE = "story_bible_genre",
  STORY_BIBLE_STYLE = "story_bible_style",
  STORY_BIBLE_STYLE_MENU = "story_bible_style_menu",
  STORY_BIBLE_SYNOPSIS_END = "story_bible_synopsis_end",
  STORY_BIBLE_SYNOPSIS_GENERATE_BUTTON = "story_bible_synopsis_generate_button",
  STORY_BIBLE_SYNOPSIS_HEADER = "story_bible_synopsis_header",
  STORY_BIBLE_CHARACTERS = "story_bible_characters",
  STORY_BIBLE_GENERATE_CAST_BUTTON = "story_bible_generate_cast_button",
  STORY_BIBLE_ADD_CHARACTER_BUTTON = "story_bible_add_character_button",
  STORY_BIBLE_GENERATE_OUTLINE_BUTTON = "story_bible_generate_outline_button",
  STORY_BIBLE_OUTLINE_HEADER = "story_bible_outline_header",
  STORY_BIBLE_CREATE_DOCUMENT = "story_bible_create_document",
  STORY_BIBLE_DRAFT_ICON = "story_bible_draft_icon",
  DRAFT_SCENES_GENERATE = "draft_scenes_generate",
  DRAFT_PROSE_GENERATE = "draft_prose_generate",
  DRAFT_PROSE_GENERATE_GO = "draft_prose_generate_go",
  DRAFT_GENERATE_PANEL = "draft_generate_panel",
  // Plugins tour anchors
  IMPORT_NOVEL_BUTTON = "import_novel_button",
  MORE_TOOLS_BUTTON = "more_tools_button",
  MORE_TOOLS_DROPDOWN = "more_tools_dropdown",
  CUSTOM_PLUGIN_BUTTON = "custom_plugin_button",
  // Feedback tour anchors
  FEEDBACK_BUTTON = "feedback_button",
  FEEDBACK_CHEVRON = "feedback_chevron",
  FEEDBACK_TYPE_DROPDOWN = "feedback_type_dropdown",
  // Paragraph spacing tour anchors
  SETTINGS_GEAR = "settings_gear",
  SETTINGS_PARAGRAPH_SPACING = "settings_paragraph_spacing",
  COLLAPSE_EMPTY_PARAGRAPHS_BUTTON = "collapse_empty_paragraphs_button",
}

export enum FixedPosition {
  BOTTOM_CENTER = "bottom-center",
}

export type TourStep = {
  id: string;
  listeningFor?: TourSignal[];
  listeningForFailure?: TourSignal[];
  /** If one of these signals fires, loop nextStep() forward to the target step id */
  skipSignals?: Partial<Record<TourSignal, string>>;
  stickies: {
    content: React.ReactNode;
    offsetX: number;
    offsetY: number;
    anchorId?: AnchorIds;
    fixedPosition?: FixedPosition;
    rotation?: number;
    arrowPosition?: ArrowPosition;
    renderIfAnchorMissing?: AnchorIds;
  }[];
};

export type Tour = {
  id: TourIds;
  variation?: ValidTourVariations;
  steps: TourStep[];
};

export const enum WriteRewriteTourVariations {
  ONBOARDING_NEW_BOOK = "onboarding_new_book",
  ONBOARDING_IMPORTED_PROJECT = "onboarding_imported_project",
  BRAINDUMP_NOT_SURE = "braindump_not_sure",
  FROM_HELP_MENU = "from_help_menu",
}

export const enum StoryBibleTourVariations {
  FROM_HELP_MENU = "from_help_menu",
  NEW_PROJECT = "new_project",
  NEW_PROJECT_FLOW = "new_project_flow",
}

export const enum PluginsQuickstartTourVariations {
  IMPORT = "import",
  NO_IMPORT = "no_import",
  FROM_HELP_MENU = "from_help_menu",
}

export const enum FeedbackTourVariations {
  IMPORTED = "imported",
  NOT_IMPORTED = "not_imported",
}

export type ValidTourVariations =
  | WriteRewriteTourVariations
  | StoryBibleTourVariations
  | PluginsQuickstartTourVariations
  | FeedbackTourVariations
  | undefined;
